import { Link } from '@tanstack/react-router';
import { PLANS, activePlans, highestTier } from '@aeon-karaoke/cloud-convex/model/plans';
import { useBillingModals } from '@/hook/useBillingModals';
import type { CurrentUser } from '@/hook/useCurrentUser';
import { MonoLabel } from './MonoLabel';

/** Nav chip naming the tier whose limits apply. A free account goes to Plan &
 * billing to compare; a subscriber opens the plan modal. */
export function PlanChip({ user }: { user: Pick<CurrentUser, 'subscriptionStatus' | 'plan'> }) {
  const { openPlan } = useBillingModals();
  const tier = highestTier(activePlans(user));
  const label = (
    <MonoLabel tone="mute" size="md" className="text-inherit">
      {PLANS[tier].name}
    </MonoLabel>
  );
  if (tier === 'free') {
    return (
      <Link to="/settings/$tab" params={{ tab: 'plan' }} className="text-mute hover:text-acc">
        {label}
      </Link>
    );
  }
  return (
    <button type="button" onClick={openPlan} className="text-mute hover:text-acc">
      {label}
    </button>
  );
}
